import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM18HCLInstall extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#8e8e8e'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 300">
                <rect width={300} height={300} rx={50} ry={50} fill={color} />
                <path
                    d="M189.09 55.81h-78.18a53.73 53.73 0 0 0-6.2 8h90.56a53.73 53.73 0 0 0-6.18-8zM150 38.8a53.3 53.3 0 0 0-29.25 8.72h58.5A53.3 53.3 0 0 0 150 38.8zM97.88 104.69a53.19 53.19 0 0 0 2.54 8h99.18a53.19 53.19 0 0 0 2.54-8zM199.59 72.1h-99.18a53.18 53.18 0 0 0-2.54 8h104.25a53.18 53.18 0 0 0-2.53-8zM150 146a53.3 53.3 0 0 0 29.25-8.72h-58.5A53.3 53.3 0 0 0 150 146zM203.6 92.4c0-1.35-.1-2.68-.2-4H96.61c-.1 1.33-.2 2.65-.2 4s.1 2.68.2 4h106.78c.1-1.32.21-2.65.21-4zM110.91 129h78.17a53.73 53.73 0 0 0 6.2-8h-90.56a53.73 53.73 0 0 0 6.19 8z"
                    fill={secondaryColor}
                />
                <circle cx={150} cy={223.11} r={9.84} fill={secondaryColor} />
                <circle cx={150} cy={257.29} r={5.7} fill={secondaryColor} />
            </svg>
        );
    }
}

export default withTheme(SvgSDM18HCLInstall);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM18HCLInstall.js